// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as LabelV4$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/LabelV4.bs.js";
import * as FormInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as FormTextInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormTextInput.bs.js";

function TemplateDetailsCmp(Props) {
  var selected_template = Props.selected_template;
  return React.createElement("div", {
              className: "mt-2 p-1"
            }, React.createElement("div", {
                  className: "heading"
                }, "Message"), selected_template !== undefined ? React.createElement(React.Fragment, undefined, React.createElement("div", {
                        className: "mt-2"
                      }, React.createElement(LabelV4$Catalyst.make, {
                            text: "Title"
                          })), React.createElement(FormTextInput$Catalyst.make, {
                        input_props: FormInput$Catalyst.make_props("", undefined, true, undefined, "", undefined, undefined, undefined, undefined, undefined, "send-message-input send-message-title", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                        textinput_props: {
                          value: selected_template.template_title
                        }
                      }), React.createElement("div", {
                        className: "mt-2"
                      }, React.createElement(LabelV4$Catalyst.make, {
                            text: "Body"
                          })), React.createElement(FormTextInput$Catalyst.make, {
                        input_props: FormInput$Catalyst.make_props("", undefined, true, undefined, "", undefined, undefined, undefined, undefined, undefined, "send-message-input send-message-body", true, undefined, undefined, undefined, undefined, undefined, undefined),
                        textinput_props: {
                          value: selected_template.template_message
                        }
                      })) : null);
}

var make = TemplateDetailsCmp;

export {
  make ,
  
}
/* react Not a pure module */
